import IDream from "motw_core/Entity/IDream";
import { emptyDream } from "source/app/presentation/MainPanel/Dreams/DreamEditor/DreamEditor";

export const PrepareCopiedDream = (dream: IDream) => {
    return {
        ...emptyDream,
        name: dream.name,
        difficulty: dream.difficulty,
        emotion: dream.emotion,
        linkid: dream.linkid,
        attributes: dream.attributes,
        isresonating: dream.isresonating,
    } as IDream;
};
